import { h, Component } from 'preact';
import Loader from '../loader/loader';
import config from '../../config.json';

export default class CampaignRedirect extends Component {
  componentWillMount() {
    console.log('Redirecting to', `${config.campaign.url}/c/${this.props.matches.campaignUid}?utm_source=trouble`);
    location.href = `${config.campaign.url}/c/${this.props.matches.campaignUid}?utm_source=trouble`;
  }

  render() {
    return (<div>
      <Loader />
      <p className="redirect">If you aren't redirected in 5 seconds then please <a href={`${config.campaign.url}/c/${this.props.matches.campaignUid}?utm_source=trouble`}>Click here</a></p>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/campaignRedirect/campaignRedirect.jsx